module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Cloud.02de888c.png";